import {
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
} from "@material-ui/core";
import { useState } from "react";
import moment from "moment";
import EnlargeImage from "../../pages/Users/EnlargeImage";
import NoDataScreen from "../../utilities/NoDataScreen";

const useStylesForTable = makeStyles({
  table: {
    width: "max-content",
    minWidth: "40rem",
  },
  // containerWidth: {
  //   minWidth: 1120,
  // },
});
interface tableHeadingAndData {
  heading: string[];
  data: any[];
  tab: string | null;
  rows: any[];
}
const DiscardedAndRepairInventoryTableComponent = ({
  heading,
  data,
  tab,
  rows
}: tableHeadingAndData) => {
  const tableClasses = useStylesForTable();

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };
  // ---------------for enlarge image modal-------------
  const [modalData, setModalData] = useState({
    image: "",
    isOpen: false,
  });

  const handleOpen = (photo: string) => {
    setModalData({ ...modalData, image: photo, isOpen: true });
  };
  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  console.log(data);

  return (
    <>
      {data.length > 0 ? (
        <>
          <TableContainer className={""}>
            <Table className={`${tableClasses.table} custom_table`} aria-label="simple table">
              <TableHead>
                <TableRow>
                  {heading.map((heading: string, index: any): any => (
                    <TableCell
                      key={heading}
                      className={`f16 fw500 ${index === 0 && "pl0"}`}
                      align="left"
                    >
                      {heading}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              {rows.length > 0 ? (<TableBody>
                {rows
                  ?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  ?.map((row: any, index: number) => (
                    <TableRow key={row.name + index}>
                      <TableCell className="f14 fw500 pl0" align="left">
                        {row.name}
                      </TableCell>
                      <TableCell className="f14 fw500" align="left">
                        {moment(row.item.returnedOn).format(
                          "DD,MMM,YYYY, h:mm A"
                        )}
                      </TableCell>
                      <TableCell className="f14 fw500" align="left">
                        {row.item.returnQuantity}
                      </TableCell>
                      <TableCell className="f14 fw500" align="left">
                        {row.item.returnUnit}
                      </TableCell>
                      <TableCell className="f14 fw500 capitalize" align="left">
                        {row.item.issuedTo}
                      </TableCell>
                      <TableCell className="f14 fw500" align="left">
                        {row.item.returnItemSnap ? (
                          <img
                            src={`${process.env.REACT_APP_PRO_URL}/images/${row.item.returnItemSnap}`}
                            alt="..."
                            className="candidate_photo pointer"
                            onClick={() =>
                              handleOpen(
                                `${process.env.REACT_APP_PRO_URL}/images/${row.item.returnItemSnap}`
                              )
                            }
                          />
                        ) : (
                          "N/A"
                        )}
                      </TableCell>
                      {tab?.toLowerCase() === "discarded inventory" && (
                        <TableCell className="f14 fw500" align="left">
                          {row.item.returnSlip ? (
                            <img
                              src={`${process.env.REACT_APP_PRO_URL}/images/${row.item.returnSlip}`}
                              alt="..."
                              className="candidate_photo pointer"
                              onClick={() =>
                                handleOpen(
                                  `${process.env.REACT_APP_PRO_URL}/images/${row.item.returnSlip}`
                                )
                              }
                            />
                          ) : (
                            "N/A"
                          )}
                        </TableCell>
                      )}
                      <TableCell className="f14 fw500 capitalize" align="left">
                        {row.item.category}
                      </TableCell>
                      <TableCell className="f14 fw500 capitalize" align="left">
                        {row.item.returnBy}
                      </TableCell>
                      {tab?.toLowerCase() === "discarded inventory" && (
                        <TableCell
                          className="f14 fw500 capitalize"
                          align="left"
                        >
                          {row?.item?.debitImpose ? "Yes" : "No"}
                        </TableCell>
                      )}
                    </TableRow>
                  ))}
              </TableBody>) : (<TableRow>
                <TableCell colSpan={10} align="center">
                  No Data Found
                </TableCell>
              </TableRow>)}
            </Table>
          </TableContainer>
          {/* ---------------Enlarge Image Modal---------- */}
          <EnlargeImage modalData={modalData} />

          <TablePagination
            rowsPerPageOptions={[2, 5, 10, 25]}
            component="div"
            count={data.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </>
      ) : (
        <NoDataScreen text={`There are no data available for ${tab}.`} />
      )}
    </>
  );
};

export default DiscardedAndRepairInventoryTableComponent;
